<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div
    v-if="isLoading"
    v-dragscroll
    class="mt-4"
  >
    <div
      class="d-flex align-center px-4"
    >
      <div class="d-flex flex-column">
        <div class="d-flex">
          <div>{{ $t('currentStore') }}</div>
          <div class="font-weight-bold ml-2">
            {{ currentStore?.name ?? '' }}
          </div>
        </div>
      </div>
      <v-spacer />
      <v-btn
        v-if="!addNew"
        :icon="!$vuetify.breakpoint.mdAndUp"
        class="amber lighten-4 black--text"
        elevation="0"
        @click="addNew = !addNew"
      >
        <v-icon
          :center="!$vuetify.breakpoint.mdAndUp"
          :left="$vuetify.breakpoint.mdAndUp"
        >
          mdi-plus
        </v-icon>
        <template v-if="$vuetify.breakpoint.mdAndUp">
          {{ $t('NewBusiness') }}
        </template>
      </v-btn>
      <v-btn
        v-if="addNew"
        :icon="!$vuetify.breakpoint.mdAndUp"
        class="amber lighten-4 black--text"
        elevation="0"
        @click="addNew = !addNew"
      >
        <v-icon
          :center="!$vuetify.breakpoint.mdAndUp"
          :left="$vuetify.breakpoint.mdAndUp"
        >
          mdi-arrow-left
        </v-icon>
        <template v-if="$vuetify.breakpoint.mdAndUp">
          {{ $t('ToReturn') }}
        </template>
      </v-btn>
    </div>
    <template v-if="!addNew">
      <div

        class="my-3"
      >
        <div>
          <div style="width: 4px" />
          <v-list-item
            v-for="i in restaurantInfos"
            :key="i.deviceId"
            :class="i.deviceId === currentStore.deviceId?'amber lighten-4':''"
            @click="useDeviceId(i.deviceId)"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ i.name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ i.adress1 }}
                {{ i.postCode }}
                {{ i.city }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <div
                class="d-flex"
                @click.stop="showQRCode(i)"
              >
                <v-icon>
                  mdi-qrcode
                </v-icon>
                <div class="ml-2">
                  {{ $t('storeQr') }}
                </div>
              </div>
            </v-list-item-action>
            <v-list-item-action>
              <v-icon @click.stop="getUnbindStoreInfo(i)">
                mdi-delete
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="d-flex justify-center align-center my-4">
        <v-card
          class="d-flex align-center justify-center"
          color="grey lighten-4"
          elevation="0"
          height="253"
          style="position: relative;flex-shrink: 0;"
          width="190"
          @click="addNewStore('bind')"
        >
          <div class="text-center">
            <v-icon size="48">
              mdi-home-circle
            </v-icon>
            <div>
              {{ $t('BindShop') }}
            </div>
          </div>
        </v-card>
        <v-card
          class="d-flex align-center justify-center ml-10"
          color="grey lighten-4"
          elevation="0"
          height="253"
          style="position: relative;flex-shrink: 0;"
          width="190"
          @click="addNewStore('buy')"
        >
          <div class="text-center">
            <v-icon size="48">
              mdi-home-plus
            </v-icon>
            <div>
              {{ $t('AddNewRestaurant') }}
            </div>
          </div>
        </v-card>
      </div>
    </template>
    <v-dialog
      v-model="showAddDialog"
      max-width="525px"
      persistent
    >
      <v-card
        class="pa-4"
        color="#f6f6f6"
      >
        <div class="text-center">
          <div v-if="error">
            <h1 class="error--text">
              {{ $t('CodeEnteredIncorrect') }} ❌
            </h1>
            <h4 class="mt-2 d-flex align-center justify-center">
              {{ $t('CodeEnteredIncorrectHint') }}
            </h4>
          </div>
          <div v-else>
            <h1>{{ $t('AadenPOS') }}</h1>
            <h4 class="mt-2 d-flex align-center justify-center">
              {{ $t('AddNewRestaurantsHint') }}
              <v-tooltip top>
                <template #activator="{ on, attrs }">
                  <v-icon
                    class="ml-1"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{ $t('AddNewRestaurantsHintHelp') }}</span>
              </v-tooltip>
            </h4>
          </div>
          <div class="pa-4">
            <v-otp-input
              :value="input"
              class="mt-2"
              disabled
              length="6"
              type="password"
            />
            <div
              v-if="!bindLoading"
              style="display: grid;grid-template-columns: repeat(4,1fr);grid-gap: 5px"
            >
              <v-card
                v-for="(k,o) in key"
                :key="k+o"
                color="white"
                elevation="0"
                @click="keyInput(k)"
              >
                <v-responsive
                  :aspect-ratio="1"
                  class="d-flex align-center justify-center text-h2"
                >
                  {{ k }}
                </v-responsive>
              </v-card>
            </div>
            <div
              v-else
              class="pa-2 d-flex align-center justify-center"
              style="height: 300px;"
            >
              <v-progress-circular indeterminate />
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showLessUseCount"
      max-width="600px"
      persistent
    >
      <v-card
        class="pa-4"
      >
        <div class="d-flex align-center">
          <div class="text-h3 font-weight-bold">
            {{ $t('BindedRestaurant') }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="showLessUseCount = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex align-center justify-center flex-column mt-8">
          <div class="text-h3">
            {{ $t('BindedRestaurantAmountHint') }}
          </div>
          <v-btn
            class="amber lighten-4 black--text mt-8 mb-6"
            elevation="0"
            height="50px"
            width="75%"
            @click="jumpToPersonalPage"
          >
            {{ $t('BindedResturantSlotsBuy') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirmUnbindDialog"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div class="d-flex">
          <div class="text-body-1">
            {{ $t('ReleaseConfirmation') }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="confirmUnbindDialog = false"
            >
              <v-icon>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex align-center justify-center flex-column mt-6">
          <span class="text-body-1">{{ $t('SelectShopToRelease') }}:</span>
          <span class="text-h4 font-weight-bold">{{ waitUnbindDeviceInfo.name }}</span>
        </div>
        <v-btn
          :loading="checkDeleteLoading"
          block
          class="mt-8"
          color="amber lighten-4 black--text"
          elevation="0"
          @click="confirmUnbind"
        >
          {{ $t('CancelConfirmation') }}
        </v-btn>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="storeQrDialog"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div class="d-flex">
          <div class="text-h3 font-weight-bold">
            {{ $t('storeQR') }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="storeQrDialog = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div
          v-if="qrInfo"
          class="d-flex justify-center align-center flex-column py-6"
        >
          <qr-code-display
            :data="qrInfo"
            :size="'196'"
            class="mt-4"
          />
        </div>
        <div v-else>
          {{ $t('storeNotHaveQR') }}
        </div>
      </v-card>
    </v-dialog>
  </div>
  <div v-else>
    <div
      class="d-flex align-center justify-center flex-column"
      style="height: 300px"
    >
      <div class="mb-10 text-h3 font-weight-bold">
        {{ $t('waitAMoment') }}
      </div>
      <v-progress-circular
        indeterminate
        size="64"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import { addStore, useStore } from '@/model/dataLayer/api/SaaS/storeService'
import { decodeDeviceId, getInfoForDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { getCurrentUserId, getShopQR, getUserCurrentStoreInfo } from '@/model/dataLayer/api/SaaS/user'
import { dragscroll } from 'vue-dragscroll/src/main'
import {
  deleteSelectedStore,
  getAllStoreIdForUser,
  getAllStoreInfoForUser
} from '@/model/dataLayer/api/SaaS/subscriptionService'
import { ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import router from '@/model/global/router'
import { sumBy } from 'lodash'
import QrCodeDisplay from '@/views/SaaS/widget/QrCodeDisplay.vue'

const key = [
  '7', '8', '9', '',
  '4', '5', '6', '',
  '1', '2', '3', '',
  'X', '0', '', 'C'
]

export default {
  name: 'AddDevicePage',
  components: { QrCodeDisplay },
  directives: {
    dragscroll
  },
  props: {
    dialogStatus: {}
  },
  data: function () {
    return {
      qrInfo: '',
      storeQrDialog: false,
      currentStore: '',
      realBindStore: {},
      checkDeleteLoading: false,
      confirmUnbindDialog: false,
      waitUnbindDeviceInfo: '',
      ownStoreProductCode: [ProductCodes.oldDevice, ProductCodes.base, ProductCodes.extraStore],
      allOwnStoreLength: [],
      addNew: false,
      storeListOfId: [],
      slideGroup: null,
      showLessUseCount: false,
      isLoading: false,
      key,
      input: '',
      error: false,
      restaurantInfos: [],
      showAddDialog: false,
      readyToUseCount: 0,
      bindLoading: false
    }
  },
  computed: {
    totalStoreLength () {
      const res = []
      return sumBy(res, x => {
        return parseInt(x.count ?? '1', 10)
      })
    },
    ...mapGetters(['totalLicenseCount', 'availableLicenseCount']),
    ...mapState(['license'])
  },
  watch: {
    dialogStatus (val) {
      if (!val) {
        this.addNew = false
      }
    },
    showAddDialog () {
      this.input = ''
    },
    availableLicenseCount: {
      immediate: true,
      async handler (val) {
        this.readyToUseCount = await val
      }
    }
  },
  async mounted () {
    await this.loadData()
  },
  methods: {
    async showQRCode (item) {
      const res = await getShopQR(item.deviceId) ?? ''
      this.qrInfo = res.bindingUUID
      this.storeQrDialog = true
    },
    ...mapMutations(['showErrorDialog']),
    async confirmUnbind () {
      this.checkDeleteLoading = true
      await deleteSelectedStore(this.realBindStore.id)
      this.confirmUnbindDialog = false
      this.checkDeleteLoading = false
      await this.loadData()
      await useStore(this.storeListOfId[0])
      this.close(true)
    },
    async getUnbindStoreInfo (info) {
      this.waitUnbindDeviceInfo = info
      this.realBindStore = (await getAllStoreInfoForUser(getCurrentUserId())).find(
        it => it.deviceId.toString() === info.deviceId.toString())
      this.confirmUnbindDialog = true
    },
    async loadData () {
      this.isLoading = false
      this.storeListOfId = (await getAllStoreIdForUser(getCurrentUserId()))
      this.restaurantInfos = await Promise.all(this.storeListOfId.map(async (id) => {
        return {
          ...await getInfoForDeviceId(id),
          deviceId: id
        }
      }))
      try {
        const mainStoreDevice = (await getUserCurrentStoreInfo()).currentStoreId
        this.currentStore = this.restaurantInfos.find(it => it.deviceId.toString() === mainStoreDevice.toString())
      } catch (e) {
        console.log(e, 'e')
      }
      if (this.restaurantInfos.length === 0) {
        this.showAddDialog = true
      }
      this.isLoading = true
    },
    jumpToPersonalPage () {
      this.showLessUseCount = false
      this.$emit('closeDialog')
      this.$router.push('/products/productsInfo')
    },
    async addNewStore (item) {
      if (item === 'bind') {
        this.showAddDialog = true
      } else {
        await router.push('/SaaS')
      }
    },
    jumpToAddProductPage () {
      this.$router.push('/personalInfo')
      this.$emit('closeDialog')
    },
    async useDeviceId (deviceId) {
      await useStore(deviceId, true)
      this.$emit('closeDialog', true)
    },
    close (needReload = false) {
      this.$emit('closeDialog', needReload)
    },
    async addStore (deviceId) {
      await addStore(deviceId)
      await useStore(deviceId, true)
      await this.loadData()
      this.close(true)
    },
    keyInput (key) {
      switch (key) {
        case 'C':
          this.input = ''
          break
        case 'X':
          this.showAddDialog = false
          break
        default:
          this.input += key
      }
      this.error = false
      if (this.input.length > 5) {
        this.tryLogin()
      }
    },
    async tryLogin () {
      this.bindLoading = true
      const outId = decodeDeviceId(this.input).toString()
      try {
        const res = await getInfoForDeviceId(outId)
        if (res.broken) {
          this.error = true
          this.input = ''
        } else {
          await this.addStore(outId)
          this.showAddDialog = false
        }
      } catch (e) {
        this.error = true
        this.input = ''
      } finally {
        this.bindLoading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
